import { render, staticRenderFns } from "./FreemiumFilterBadge.vue?vue&type=template&id=3479b957&"
import script from "./FreemiumFilterBadge.vue?vue&type=script&lang=ts&"
export * from "./FreemiumFilterBadge.vue?vue&type=script&lang=ts&"
import style0 from "./FreemiumFilterBadge.vue?vue&type=style&index=0&id=3479b957&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports